import resume from '../assets/pdf/M-Ahad-Resume.pdf'

export const headerData = {
    name: 'Ahad Abbasi',
    title: "Security Researcher | Penetration Tester | Cyber security",
    desciption:"I like to break things to make them better.\n It takes 20 years to build a reputation and few minutes of cyber-incident to ruin it.",
    image: 'https://i.ibb.co/J3X98xd/Ahad-Abbasi.png',
    resumePdf: resume
}
